import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import CustomerInfo from "./pages/CustomerInfo";
import Service from "./pages/Service";
import PayInfo from "./pages/PayInfo";
import Response from "./pages/Response";
import Login from "./pages/Login";
import Register from "./pages/Register";
import { AuthRoute } from "./components/AuthRoute";

export default function App() {
  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column' 
    }}>
      <Header />
      <main style={{ flex: '1' }}>
        <Routes>
        {/* Các route không cần đăng nhập */}
        {/* <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} /> */}

        {/* Các route cần đăng nhập */}
        <Route
          path="/"
          element={
            <AuthRoute isAuthProtected={true}>
              <Home />
            </AuthRoute>
          }
        />
        <Route
          path="/thong-tin-hanh-khach"
          element={
            <AuthRoute isAuthProtected={true}>
              <CustomerInfo />
            </AuthRoute>
          }
        />
        <Route
          path="/thong-tin-dich-vu"
          element={
            <AuthRoute isAuthProtected={true}>
              <Service />
            </AuthRoute>
          }
        />
        <Route
          path="/thong-tin-thanh-toan"
          element={
            <AuthRoute isAuthProtected={true}>
              <PayInfo />
            </AuthRoute>
          }
        />
        <Route
          path="/thong-tin-ve"
          element={
            <AuthRoute isAuthProtected={true}>
              <Response />
            </AuthRoute>
          }
        />
        {/* Add other routes as needed */}
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
